<template>
  <div v-if="usuario" class="info-historico">
    <h1>{{ usuario.nome }}</h1>
  </div>
</template>

<style lang="scss">
  .info-historico {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
  }
</style>

<script>
export default {
  name: 'InformacoesHistorico',

  props: {
    usuarioId: {
      required: true,
      type: String | Number
    }
  },

  data() {
    return {
      usuario: null
    }
  },

  mounted() {
    this.buscarDadosUsuario();
  },

  methods: {
    async buscarDadosUsuario() {
      try {
        const { data: response } = await this.$http.get(`/v-usuario/${this.usuarioId}`);
        this.usuario = response;
      } catch(e) {
        console.error(e);
      }
    }
  }
}
</script>